module.exports = __webpack_public_path__ + "img/CoronaConcert-967x683.663f075c.png";